export const ACTION_CODE = 'DASHBOARD_CONSULTANT_PRODUCTION' + '_ACTION';
